export default __webpack_public_path__ + "static/media/portfolio_5.62d96342.png";